import { Link } from 'wouter';
import { useTranslation } from 'react-i18next';
import { Facebook, Mail, Phone } from 'lucide-react';

export function Footer() {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-slate-900 border-t border-slate-800 w-full">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          <div className="col-span-2 md:col-span-1 space-y-4">
            <div className="flex items-center space-x-2">
              <img 
                src="/logo-transparent.png" 
                alt="FraudCheck BD" 
                className="h-6 w-6"
                width="24"
                height="24"
                loading="lazy"
              />
              <span className="text-lg font-bold text-green-400">FraudCheck BD</span>
            </div>
            <p className="text-sm text-slate-300">
              {t('footer.description')}
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/people/Fraud-Check-BD/61577109517985/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-slate-500 hover:text-blue-400 cursor-pointer transition-colors"
                aria-label="Follow us on Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a 
                href="mailto:support@fraudcheck.bd"
                className="text-slate-500 hover:text-green-400 cursor-pointer transition-colors"
                aria-label="Email us at support@fraudcheck.bd"
              >
                <Mail className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-semibold mb-3 md:mb-4 text-white text-sm md:text-base">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link href="/" className="text-slate-400 hover:text-green-400 transition-colors">
                  {t('common.home')}
                </Link>
              </li>
              <li>
                <Link href="/report" className="text-slate-400 hover:text-green-400 transition-colors">
                  {t('header.reportFraud')}
                </Link>
              </li>
              <li>
                <Link href="/analytics" className="text-slate-400 hover:text-green-400 transition-colors">
                  {t('common.analytics')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-3 md:mb-4 text-white text-sm md:text-base">{t('footer.legal')}</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link href="/about" className="text-slate-400 hover:text-green-400 transition-colors">
                  {t('footer.aboutUs')}
                </Link>
              </li>
              <li>
                <Link href="/privacy" className="text-slate-400 hover:text-green-400 transition-colors">
                  {t('footer.privacyPolicy')}
                </Link>
              </li>
              <li>
                <Link href="/terms" className="text-slate-400 hover:text-green-400 transition-colors">
                  {t('footer.termsOfService')}
                </Link>
              </li>
              <li>
                <Link href="/disclaimer" className="text-slate-400 hover:text-green-400 transition-colors">
                  {t('footer.disclaimer')}
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-span-2 md:col-span-1">
            <h3 className="font-semibold mb-3 md:mb-4 text-white text-sm md:text-base">{t('footer.contact')}</h3>
            <div className="space-y-2 text-sm text-slate-400">
              <div className="flex items-center space-x-2">
                <Mail className="h-4 w-4 flex-shrink-0" />
                <span className="truncate">support@fraudcheck.bd</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="h-4 w-4 flex-shrink-0" />
                <span>+880-1700-000000</span>
              </div>
              <p className="mt-3 md:mt-4 text-xs md:text-sm">
                {t('footer.emergencyHotline')}
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 text-center text-sm text-slate-400">
          <p>{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
}
